import React, { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import ConfirmDialog from 'ui/components/ConfirmDialog/ConfirmDialog'
import { getActiveContextSubTextList } from './BidSubmitConfirmDialog.helper'

type BidSubmitConfirmDialogProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  systemName: string
  isPreview: boolean
}

export function BidSubmitConfirmDialog({
  open,
  onClose,
  onConfirm,
  systemName,
  isPreview,
}: BidSubmitConfirmDialogProps): ReactNode {
  const { t } = useTranslation()

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      textObject={{
        title: t('Confirm bid submission'),
        text: t('You are about to submit bids. Please verify the active context:'),
        confirm: t('Submit'),
        deny: t('Cancel'),
      }}
      subTextList={getActiveContextSubTextList({ systemName, isPreview, stage: process.env.REACT_APP_STAGE }, t)}
    />
  )
}
